module.exports = __webpack_public_path__ + "assets1763535487631/img/home-img.ff28be9e.jpg";